<template>
  <section v-loading.fullscreen.lock="loading" class="messageDto">
    <template v-if="MessageList.length">
      <div v-for="(item,index) in MessageList" :key="index" class="message-item" @click="detailsShowFn(item)">
        <div class="message-logo">
          <img :src="require('@/assets/icon/icon-message.png')" alt="">
        </div>
        <div class="message-content">
          <div class="topContent">
            <div class="contentLeft">
              <div
                class="hint"
                :style="{backgroundColor:item.is_read===1?'#fff':'red'}" />
              <span class="title">{{ item.title }}</span>
            </div>
            <span class="date">{{ item.created_at }}</span>
          </div>
          <div class="content">
            {{ item.content }}
          </div>
        </div>
      </div>
      <span
        v-if="page<lastPage"
        class="addList"
        @click="addList"
      >点击加载更多...</span>
    </template>
    <div v-else class="noData">
      暂无数据
    </div>
    <MessageDetails
      v-if="detailsShow"
      :value="itemData"
      @hide="detailsShow=false"
    />
  </section>
</template>

<script>
import api from '@/api/app'
import comDtoData1 from './comDtoData1.vue'
import MessageDetails from '@/views/notes/message/details/MessageDetails'
import mock from '@/utils/mock'

export default {
  components: {
    // comDtoData1,
    MessageDetails
  },
  data() {
    return {
      messageInfo: mock.notes.message.viewInfo,
      messageInit: mock.notes.message.init,
      loading: false,
      MessageList: [],
      page: 1,
      lastPage: 1,
      detailsShow: false,
      itemData: {}
    }
  },
  computed: {},
  created() {
    this.loading = true
    // this.init()
  },
  mounted() {
    this.handleMessageList()
  },
  methods: {
    handleMessageList() {
      this.loading = true
      var obj = {
        page: this.page,
        page_size: 15
      }
      api.notes.retrieve.message(obj).then((res) => {
        this.loading = false
        this.MessageList = this.MessageList.concat(res.data.data)
        this.lastPage = res.data.last_page
      })
    },
    // init() {
    //   this.requestParams1.id = this.$route.query.id
    //   this.initDto(this.requestParams1)
    // },
    // async initDto(v) {
    //   this.dtoObj = await this.messageInit.dto(v)
    //   this.loading = false
    // },
    control(type, condition) {
      return mock.system.global.control[type](condition)
    },
    addList() {
      this.page += 1
      this.handleMessageList()
    },
    detailsShowFn(val, index) {
      api.notes.retrieve.messageNoDetail(
        { id: val.id }
      ).then((res) => {
        this.$set(val, 'is_read', 1)
        this.$store.dispatch('user/messageActions')
      })
      this.itemData = val
      this.detailsShow = true
    }
  }
}
</script>
<style lang='scss' scoped>
.coontent{
  padding-bottom: 50px;
}
.messageDto {

  @include fun-layout(1);
   background-color: #fff;
    width: $xr-min-width;
    margin: 0 auto;
    // height: 100%;
    position: relative;
    min-height: 100%;
    margin-bottom: 10px;
    min-width: $xr-min-width;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    .message-item{
      // margin:0 50px;
      padding-bottom: 50px;
      padding: 30px 50px;
      // width: 100%;
      border-bottom: 1px solid #f3f0f0;
      display: flex;
      align-content: center;
      cursor: pointer;
      .content{
        margin-top: 20px;
      }

    }
  // > div {
  //   height: 100%;
  // }
  &-content {
    height: calc(100% - 106px);
    @include fun-layout(2);
    margin-top: 20px;

  }
}
.message-logo{
  margin-right: 10px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #2f82ff;
  position: relative;
  flex-shrink: 0;
  > img{
    width: 55%;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
}
.message-content{
  width: calc(100% - 60px);
  // flex: 1;
}
.noData{
 position: absolute;
 top: 50%;
 left: 50%;
 transform: translate(50%);
  display: flex;
  align-content: center;
  justify-content: center;
  color: #ccc;
  font-size: 12px;
}
.addList{
  display: inline-block;
  color: #333;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
  padding-bottom: 20px;
  margin-top: 20px;
}
.hint{
  width: 8px;
  height: 8px;
  border-radius: 50%;
  // background: red;
  margin-right: 4px;
  display: flex;
  flex-shrink: 0;

}
.topContent{
  display: flex;
  align-items: center;
  justify-content: space-between;
  .contentLeft{
    display: flex;
    align-items: center;
     .title{
      flex: 1;
      // display: block;
      width: 600px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .date{
    display: inline-block;
    width: 200px;
    flex-shrink: 0;
    text-align: right;
  }
}
.content{
  margin-left: 12px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 10px;
}
</style>
